<template>
    <div class="all-benefit">
        <benefit-card
            class="card-box"
            :benefitInfo="benefitInfo"
            :isHighestLevel="isHighestLevel"
            :lockInfo="curLevelLockData"
            @onCardSlide="OnCardSlide"
            @onBackClick="OnBackClick"
            @onButtonClick="openTaskListPopup"
        />
        <benefit-list
            class="list-box"
            :curCardIndex="curCardIndex"
            :benefitList="curLevelBenefitData.benefitList"
            :benefitInfo="benefitInfo"
        />
        <taskListPopup
            :visible.sync="taskListPopupVisible"
            :scoreInfoData="benefitInfo"
            :taskListInfo="taskListContent"
            @OnOpenLinkClick="opneTastListLinkClick"
            @OnCloseTaskListPop="closeTaskListPopUp"
            @OnClickNoticeType="noticeTypeClick"
            @OnMarketTipClick="marketTipClick"
        />
    </div>
</template>

<script>
import BenefitCard from '../../componets/all_benefit/BenefitNewCard';
import BenefitList from '../../componets/all_benefit/BenefitNewList';
import taskListPopup from '../../componets/taskListPopup/TaskListPopup';
import homemixin from '@common/js/mixin';
export default {
    components: {
        BenefitCard,
        BenefitList,
        taskListPopup
    },
    mixins: [homemixin],
    data() {
        return {
            benefitInfo: {},
            curCardIndex: 1,
            allBenefitList: [],
            allLockList: [],
            taskListPopupVisible: false,
            taskListContent: {},
            goSetting: false,
            titleBar: {
                fullScreen: 1,
                visible: 2
            }
        };
    },
    computed: {
        // 当前是否最高等级
        isHighestLevel() {
            const curLevelIndex = this.benefitInfo.currentLevelIndex;
            const list = this.benefitInfo.scoreSectionList || [];
            const lastLevelIndex = list.length && list[list.length - 1].levelIndex;
            return curLevelIndex === lastLevelIndex;
        },
        // 当前卡片等级的权益数据
        curLevelBenefitData() {
            return this.allBenefitList.find(ele => ele.levelIndex === this.curCardIndex) || {};
        },
        // 当前卡片等级的解锁数据
        curLevelLockData() {
            return this.allLockList.find(ele => ele.levelIndex === this.curCardIndex) || {};
        }
    },
    created() {
        if (window.PPDWebUI.os.inApp) {
            window.PPDWebUI.CommonService.setNavigation(this.titleBar);
        }
    },
    async mounted() {
        window.PPDWebUI.CommonService.setBounces({ bounces: false });
        await Promise.all([
            this.getScoreProgress(),
            this.getAllBenefitData(),
            this.getAllLockData(),
            this.getTaskList()
        ]);
        if (window.PPDWebUI.os.inApp) {
            window.PPDWebUI.ListenerService.resumeListener(async () => {
                if (this.goSetting) {
                    this.readRegisterHanlder();
                }
            });
        }
    },
    methods: {
        async getAllBenefitData() {
            const { Result, Content } = await this.$http.getCurrentGradeBenefitInfoV2();
            if (Result === 200 && Content) {
                this.allBenefitList = Content || [];
            }
        },
        async getAllLockData() {
            const { Result, Content } = await this.$http.getBenefitLockInfo();
            if (Result === 200 && Content) {
                this.allLockList = Content || [];
            }
        },
        async getScoreProgress() {
            const { Content, Result } = await this.$http.getScoreProgressV2();
            if (Result === 200) {
                this.benefitInfo = Content;
                this.curCardIndex = this.benefitInfo.currentLevelIndex || 1;
                this.trackPage();
                this.trackTaskGuiding();
            } else {
                this.$toast('网络错误，请稍后请重试！');
            }
        },
        async getTaskList() {
            const { Result, Content, ResultMessage } = await this.$http.getTaskListV2({});
            if (Result === 200 && Content) {
                this.taskListContent = Content;
            } else {
                this.POINT('h5_auth', {
                    auth_tgt: 'super_privilege_errorMsg',
                    auth_tgt_name: 'super-成长权益-报错集合',
                    page: 'super-全部权益页',
                    ret_code: Result,
                    param: ResultMessage,
                    param1: '/growth/home/getTaskListV2'
                });
            }
        },
        OnCardSlide(index) {
            this.curCardIndex = index;
            this.POINT('h5_clk', {
                page: 'super-全部权益页',
                tgt_event_id: 'h5_ACT_allPrivilege_card',
                tgt_name: 'h5-ACT-全部权益页-滑动等级卡片'
            });
        },
        OnBackClick() {
            this.goClose();
        },
        openTaskListPopup(btnText) {
            this.taskListPopupVisible = true;
            this.trackTaskGuiding(true, btnText);
        },
        closeTaskListPopUp() {
            this.taskListPopupVisible = false;
        },
        opneTastListLinkClick(value) {
            this.openLink(value);
        },
        noticeTypeClick(value) {
            this.goSetting = true;
            this.openLink(value);
        },
        handleButtonClick(task) {
            console.log('task', task);
        },
        trackPage(isClick = false) {
            let allScore = localStorage.getItem('KuserAllScore');
            const event = isClick ? 'h5_clk' : 'h5_element_imp';
            this.POINT(event, {
                tgt_event_id: 'h5_ACT_allPrivilege',
                tgt_name: 'h5-ACT-全部权益页',
                page: 'super-全部权益页',
                param: this.benefitInfo.totalScore,
                param1: allScore,
                param2: this.benefitInfo.currentLevel
            });
        },
        trackTaskGuiding(isClick = false, btnText) {
            let allScore = localStorage.getItem('KuserAllScore');
            const event = isClick ? 'h5_clk' : 'h5_element_imp';
            this.POINT(event, {
                tgt_event_id: 'h5_ACT_allPrivilege_taskydl',
                tgt_name: 'h5-ACT-全部权益页-任务引导栏',
                page: 'super-全部权益页',
                param: this.benefitInfo.totalScore,
                param1: allScore,
                param2: btnText,
                param3: `领${this.benefitInfo.taskScore}活力值`
            });
        },
        // 营销任务
        async marketTipClick(itemVlaue) {
            if (itemVlaue.taskHandler === 'LLHDongTaskHandler') {
                const { Result } = await this.$http.notifyLLHDongTaskDone({
                    taskId: itemVlaue.taskId
                });
                if (Result === 200) {
                    if (itemVlaue.redirectUrl) {
                        this.openLink(itemVlaue.redirectUrl);
                    }
                }
            } else {
                if (itemVlaue.redirectUrl) {
                    this.openLink(itemVlaue.redirectUrl);
                }
            }
        },
        /**
         * 读取通知权限
         */
        readRegisterHanlder() {
            if (PPDWebUI && PPDWebUI.PermissionService) {
                PPDWebUI.PermissionService.readPermission(
                    { permission: 'notification' },
                    result => {
                        if (
                            result &&
                            result.notification &&
                            (result.notification === 'TRUE' || result.notification === true)
                        ) {
                            this.updatePushFlag();
                        }
                    }
                );
            } else {
                console.log('PPDWebUI error!');
            }
        },
        // 上报通知开通权限
        async updatePushFlag() {
            if (this.goSetting) {
                const { Result, ResultMessage } = await this.$http.notifyPermission({
                    taskId: 310
                });
                if (Result === 200) {
                    if (ResultMessage) {
                        this.$toast({ message: ResultMessage, duration: 2000 });
                    }
                }
                this.closeTaskListPopUp();
                this.goSetting = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.all-benefit {
    padding-bottom: 40px;
    .card-box {
        height: 500px;
    }
    .list-box {
        position: absolute;
        top: 375px;
        min-height: 200px;
    }
}
</style>
